import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import DocPage from './DocPage'

const legacyMap: Record<string, React.FC> = {}

export default function DocsContent() {
  const { group, slug } = useParams<{ group: string; slug?: string }>()

  // Scroll to subsection anchor after content renders for legacy pages
  useEffect(() => {
    if (!slug) return
    const el = document.getElementById(slug)
    if (el) {
      const timeout = setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
      return () => clearTimeout(timeout)
    }
  }, [group, slug])

  if (group && legacyMap[group] && slug) {
    const Component = legacyMap[group]
    return <Component />
  }

  // Render dynamic markdown component
  return <DocPage />
}
